import React from 'react';

interface ActivateIconProps {
  size?: number;
  color?: string;
}

export const ActivateIcon: React.FC<ActivateIconProps> = ({
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* SIM card outline */}
    <path d="M19 2H8L3 7v10a3 3 0 003 3h13a3 3 0 003-3V5a3 3 0 00-3-3z" />
    {/* Checkmark */}
    <path d="M9 12l2 2 4-4" />
  </svg>
);